import React, { FC } from 'react';
import { IconButton, Table, TableBody, TableCell, TableHead, TableRow, Tooltip } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { MaterialMacroMaterial } from 'models/material-macro';
import { useTranslation } from 'react-i18next';

type MaterialMacrosItemProps = {
    materials: MaterialMacroMaterial[];
    onRemoveMaterialMacroRow: (material: MaterialMacroMaterial) => void;
};

const MaterialMacrosItem: FC<MaterialMacrosItemProps> = ({
    materials,
    onRemoveMaterialMacroRow,
}: MaterialMacrosItemProps) => {
    const { t: translate } = useTranslation(['actions-materials', 'common']);

    return (
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell>{translate('actions-materials:CODE')}</TableCell>
                    <TableCell>{translate('common:DESCRIPTION')}</TableCell>
                    <TableCell />
                </TableRow>
            </TableHead>
            <TableBody>
                {materials.map((material) => (
                    <TableRow key={material._id} hover>
                        <TableCell>{material.material?.materialCode}</TableCell>
                        <TableCell>{material.material?.description}</TableCell>
                        <TableCell align="right">
                            <Tooltip title={translate('common:REMOVE').toString()}>
                                <IconButton
                                    size="small"
                                    onClick={() => onRemoveMaterialMacroRow(material)}
                                    data-test="material-macros-item.remove-material"
                                >
                                    <DeleteIcon fontSize="small" />
                                </IconButton>
                            </Tooltip>
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );
};

export default MaterialMacrosItem;
